module.exports = {    
    AWS_ROUTE : 'https://aub5z3ac2f.execute-api.us-east-1.amazonaws.com/Dev',
    AWS_XKEY  : '7OQh9WjwdH1KOVpzW1qZJ6OhXKjVo9op3LcDn767',
    AWS_APPID : 'eyJhbGciOiJIUzI1NiJ9.TGlua3JNb2JpbGVXZWJTaXRl.HcGxemR43w4rXBl1qh6iXz_Ca1xh8gJkllkwp7hxuSw',    
    ABOUT     : 'Omega Linkr-MBT @2021 (v1.18.0)'
}